import Vue from "vue";
// 引用公共方法类
import * as util from '@/common/js/modules/util.js'
// 导入路由监听函数
import {render} from "./util";
// 按需导入iview-ui
import "./plugins/iview/ui-settings.js";
import './plugins/iview/index.less';
// 导入主应用工具类库
import LibraryJs from "./common/js";
// 导入主应用ui库
import LibraryUi from "./common/ui/";

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.use(ElementUI);

//导入路由导航守卫
import '@/permission'

// import * as Sentry from '@sentry/browser';
// import { Vue as VueIntegration } from '@sentry/integrations';
//
//
// Sentry.init({
//     dsn: 'http://bf6c77c761024cc3a4ab30ac42e94059@47.114.6.170:9000/4',
//     integrations: [new VueIntegration({Vue, attachProps: true})],
//     beforeBreadcrumb (breadcrumb, hint) {
//         return breadcrumb.category === 'ui.click' ? null : breadcrumb;
//     },// 丢弃ui.click的面包屑
//     release: '1.1.1',
//     // environment: 'Production'// Development：开发环境  Production：生产环境  staging：用户反馈
//     environment: process.env.NODE_ENV === 'development' ? 'Development' : 'Production'
// });

//将公共方法类挂载到vue原型上
Vue.prototype.$util = util;
//将主应用工具类库挂载到vue原型上
Vue.prototype.$libraryJs = LibraryJs;
Vue.use(LibraryUi);
Vue.config.productionTip = false;

// 执行主应用渲染函数
render();

